import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import {  LoanMonthData} from "@/data/loanData";

export default function DisbursementChart({ rows }: { rows: LoanMonthData[] }) {
  const chartData = rows.map((d) => ({
    month: d.month.replace(" 2025", " '25").replace(" 2026", " '26"),
    disbursed: d.totalDisbursed / 1_000_000,
    collected: d.collected / 1_000_000,
  }));

  return (
    <div className="rounded-lg border border-border bg-card p-5 shadow-sm">
      <h3 className="text-lg font-semibold text-card-foreground mb-1">Disbursement vs Collection</h3>
      <p className="text-sm text-muted-foreground mb-4">Monthly amounts in millions</p>

      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="colorDisbursed" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="hsl(173, 58%, 39%)" stopOpacity={0.3} />
              <stop offset="95%" stopColor="hsl(173, 58%, 39%)" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorCollected" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="hsl(199, 89%, 48%)" stopOpacity={0.3} />
              <stop offset="95%" stopColor="hsl(199, 89%, 48%)" stopOpacity={0} />
            </linearGradient>
          </defs>

          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220, 13%, 90%)" />
          <XAxis dataKey="month" tick={{ fontSize: 11, fill: "hsl(220, 10%, 46%)" }} tickLine={false} axisLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "hsl(220, 10%, 46%)" }} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}M`} />
          <Tooltip
            contentStyle={{ backgroundColor: "hsl(0, 0%, 100%)", border: "1px solid hsl(220, 13%, 90%)", borderRadius: "8px", fontSize: 12 }}
            formatter={(value: number) => [`${value.toFixed(1)}M`, ""]}
          />
          <Area type="monotone" dataKey="disbursed" stroke="hsl(173, 58%, 39%)" fill="url(#colorDisbursed)" strokeWidth={2} name="Disbursed" />
          <Area type="monotone" dataKey="collected" stroke="hsl(199, 89%, 48%)" fill="url(#colorCollected)" strokeWidth={2} name="Collected" />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
